/** The Brain's front door: Inlinea staff only, Microsoft 365 and a security key. */
import { useState } from "react";
import { useSearchParams } from "react-router";
import { AuthAlert, AuthShell } from "../kit/Auth";
import { Icon } from "../kit/Icon";
import { Button, PasswordInput } from "../kit/ui";

export const BRAIN_SCENE = { you: "you · staff", target: "brain", support: "Every tenant, partner, release and machine on the platform, run from one audited place." };

// The typed email survives the round trip through the server when sign-in fails, without riding in the address.
const EMAIL_KEY = "brain-signin-email";
const remembered = () => {
  try {
    return sessionStorage.getItem(EMAIL_KEY) ?? "";
  } catch {
    return "";
  }
};
const remember = (form: HTMLFormElement) => {
  try {
    sessionStorage.setItem(EMAIL_KEY, String(new FormData(form).get("email") ?? ""));
  } catch {
    /* private window: nothing to keep */
  }
};

export function SignIn() {
  const [sp] = useSearchParams();
  const error = sp.get("error");
  const ret = sp.get("return") ?? "/";
  const dev = sp.get("dev") === "1";
  const [busy, setBusy] = useState<"" | "password" | "dev">("");
  return (
    <AuthShell product="Brain" tag="Internal" scene={BRAIN_SCENE} help="For the Inlinea team. Every sign-in and every action is recorded in the audit trail.">
      <h1 className="auth-title">Sign in to the Brain</h1>
      <p className="auth-lead">Use your password or Microsoft 365, then your security key.</p>
      {dev && (
        <form className="auth-form" method="post" action="/auth/dev" onSubmit={() => setBusy("dev")}>
          <AuthAlert tone="amber">Local development sign-in. It works only on this machine.</AuthAlert>
          <div className="field">
            <label htmlFor="dem">Email</label>
            <input id="dem" className="input" name="email" type="email" required defaultValue="bahaa@inlineasecurity.com" />
          </div>
          <input type="hidden" name="name" value="Bahaa" />
          <input type="hidden" name="return" value={ret} />
          <Button type="submit" className="xl" icon="person-key" busy={busy === "dev"}>Sign in locally</Button>
        </form>
      )}
      <form className="auth-form" method="post" action="/auth/password" onSubmit={(e) => (remember(e.currentTarget), setBusy("password"))}>
        {error && <AuthAlert>{error}</AuthAlert>}
        <div className="field">
          <label htmlFor="em">Work email</label>
          <input id="em" className="input" name="email" type="email" autoComplete="username" required autoFocus={!dev} placeholder="you@inlineasecurity.com" spellCheck={false} defaultValue={error ? remembered() : ""} />
        </div>
        <div className="field">
          <label htmlFor="pw">Password</label>
          <PasswordInput id="pw" name="password" required />
        </div>
        <input type="hidden" name="return" value={ret} />
        <Button type="submit" kind="primary" className="xl" busy={busy === "password"}>{busy === "password" ? "Signing in…" : "Sign in"}</Button>
      </form>
      <div>
        <p className="auth-or">or</p>
        <a className="btn xl" data-idp-method href={`/auth/sso/microsoft?return=${encodeURIComponent(ret)}`}>
          <Icon name="logos:microsoft-icon" size={16} /> Continue with Microsoft 365
        </a>
      </div>
    </AuthShell>
  );
}
